// extracted by mini-css-extract-plugin
export default {"headingText":"styles_headingText__5cTDP","paraText":"styles_paraText__ZlT+Z","servicesCards":"styles_servicesCards__Pucts"};